<template>
    <div class="news-container">
        <div :class="['news-menu',{'fixed-sticky':isMenuFixed}]">
            <div :class="['menu-item',{'active':item.id === selected_category_id}]" v-for="(item, index) in category_list" :key="index" @click="choose_category(item.id)">{{ item.title }}</div>
        </div>
        <div class="news-page-body">
            <div :class="['left-menu',{'menu-sticky':isMenuFixed}]">
                <div class="menu-title">{{sel_category.title}}</div>
                <div class="category-sub-title"></div>
                <ul>
                    <li v-for="(item, index) in sub_category_list" :key="index" @click="choose_sub_category(item.id)"
                        :class="item.id === selected_sub_category_id ? 'active' : ''">{{ item.title }}</li>
                </ul>
            </div>
            <!-- {{ isMenuFixed }} -->
            <div :class="['left-menu-placeholder',{show:isMenuFixed}]"></div>
            <div class="right-content">
                <div class="right-top" v-if="!selected_sub_category_id">
                    <div class="banner">
                        <div class="swiper-container">
                            <swiper :options="swiperOptions" ref="mySwiper" v-if="banner_list.length && show_swiper">
                                <!-- Slides -->
                                <swiper-slide v-for="(item,index) in banner_list" :key="index">
                                    <img :src="item.image" class="swiper-img"  @click="onSwiperClick(item)" />
                                </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                            </swiper>
                        </div>
                    </div>
                    <div class="hot-news">
                        <div class="hot-news-title-box">
                            <div class="hot-news-title">热门资讯<span>HOT</span></div>
                        </div>
                        <div class="hot-news-list">
                            <div class="hot-news-item" v-for="(v,k) in hot_list" :key="`hot-`+k" @click="onDetailClick(v)">
                                <div class="item-box">
                                    <img :src="v.cover|default_img" class="cover-img" />
                                    <div class="title-time-box">
                                        <div class="title">{{v.title}}</div>
                                        <div class="time">{{v.create_time}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-list-content">
                    <div class="list-item" v-for="(v,k) in infiniteList" :key="`list`+k" @click="onDetailClick(v)">
                        <img :src="v.cover|default_img" class="cover-img" />
                        <div class="list-item-title">{{v.title}}</div>
                        <div class="list-item-date">{{v.create_time}}</div>
                    </div>
                </div>
                <div class="more-btn">
                    <Button @click="getInfiniteList(false)" shape="circle" class="btn">{{ infiniteEnded ? '没有更多' :'加载更多' }}</Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { GetBannerList, AddBannerStat } from '@/api/index';
import { InfoCategory, InfoHotList, InfoList } from '@/api/social';
import infinite from '@/mixins/infinite';
import C from '@/utils/constant';
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper';
export default {
    name: 'InfoIndex',
    components: {
        swiper,
        swiperSlide
    },
    mixins:[infinite],
    data() {
        return {
            swiperOptions: {
                // 核心配置
                slidesPerView: 1,           // 每页显示 1 张幻灯片
                centeredSlides: true,       // 当前幻灯片居中显示
                spaceBetween: 10,           // 幻灯片间距
                loop: true,                 // 启用循环模式
                loopedSlides: 0,
                grabCursor: true,           // 拖动时显示抓手光标
                autoplay: {
                    delay: 3000, // 3秒切换
                    disableOnInteraction: false // 手动滑动后继续自动播放
                },

                pagination: {
                    el: '.swiper-pagination', // 指定分页器容器选择器
                    type: 'bullets',          // 类型：bullets（圆点）、fraction（分数）、progress（进度条）等
                    clickable: true,          // 允许点击分页器切换幻灯片
                    bulletActiveClass: 'my-swiper-pagination-active', // 自定义激活状态类名
                },
                on: {
                    slideChange: this.onSlideChange, // 轮播图切换时的回调
                    init: this.onSwiperInit, // 轮播图初始化时的回调
                },
            },
            selected_category_id: 0,
            selected_sub_category_id: 0,
            category_list: [],
            banner_list:[],
            hot_list: [],
            lastScrollTop:0,
            loadingMore:false,
            first_loading:true,
            show_swiper:true,
            isMenuFixed:false,
            menuOffsetTop:0,
 			keyword: '',
            currentBannerIndex: 0, // 当前轮播图索引
            exposedBanners: new Set(), // 已曝光的banner ID集合
        }
    },
    computed:{
        sub_category_list() {
            let cate = this.category_list.find(v=>v.id===this.selected_category_id)
            return cate ? cate.children : []
        },
        sel_category(){
            return this.$_.cloneDeep(this.category_list.find(item => item.id === this.selected_category_id)) || {};
        }
    },
    watch:{
        selected_category_id(newVal, oldVal){
            this.selected_sub_category_id = 0;
            this.getHotList();
            this.onGetBannerList();
            this.getInfiniteList(true).finally(()=>{
                this.first_loading = false;
            });
        },
        selected_sub_category_id(newVal, oldVal) {
            if(newVal > 0) {
                this.getInfiniteList(true).finally(()=>{
                    console.log('aaa_1');
                    this.first_loading = false;
                });
            }
        },
    },
    beforeRouteEnter(to, from, next) {
			next((vm) => {
			// 通过 `vm` 访问组件实例
			vm.$emit("changeFooter", 'dark');
			});
		},	
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.handleResize);
        // 监听 Header 组件的同页面搜索事件
        this.$EventBus.$on('onHeaderSearch', (data) => {
            this.keyword = data?.keyword || '';
            this.getInfiniteList(true); // 执行你的搜索方法
        });
        
        this.getCategoryList().then(() => {
            // return this.getInfiniteList(true);
        }).finally(() => {
            if(this.$route.params.pid) {
                this.selected_category_id = this.$route.params.pid
            }
            if(this.$route.params.cid) {
                setTimeout(() => {
                    this.selected_sub_category_id = this.$route.params.cid
                }, 200)
            }
        })
        this.getHotList()
        this.onGetBannerList();
        this.calculateMenuOffset(); 
    },
    beforeDestroy(){
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleResize);
        this.$EventBus.$off('onHeaderSearch');
    },
    methods: {
        calculateMenuOffset() {
            this.$nextTick(() => {
                // 计算菜单距离页面顶部的距离
                const menuEl = document.querySelector('.news-menu');
                if (menuEl) {
                    // 获取元素相对于视口的位置
                    const rect = menuEl.getBoundingClientRect();
                    // 加上页面滚动的距离，得到元素距离页面顶部的实际距离
                    this.menuOffsetTop = rect.top + window.pageYOffset;
                }
            });
        },
        handleResize() {
            // 窗口大小改变时重新计算菜单偏移量
            this.calculateMenuOffset();
        },
        handleScroll(){
            // console.log('触底加载');
            // 获取当前滚动位置
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            console.log('scroollTop',scrollTop);
            // if(scrollTop < 10){
            //     console.log('scrollTop<=10');
            //     // this.isMenuFixed = false;
            //     this.$set(this,'isMenuFixed',false);
            // }
            console.log(this.menuOffsetTop-80,'menuOffsetTop');
            // 判断是否需要固定菜单
            if (scrollTop >= 80) { // 80是header的高度
                this.isMenuFixed = true;
            } else {
                this.isMenuFixed = false;
            }

            // 保存上一次滚动位置
            if (typeof this.lastScrollTop === 'undefined') {
                this.lastScrollTop = 0;
            }

            if(scrollTop < this.lastScrollTop){
                return;
            }

            this.lastScrollTop = scrollTop;

            this.$nextTick(() => {
                const el = this.$parent.$refs.footer.$el;
                if (!el) return;
                console.log('aaa');
                const rect = el.getBoundingClientRect();

                // 页面滚动到底部还剩 50px 时触发
                const offsetBottom = rect.top - window.innerHeight;
                // console.log('offsetBottom',offsetBottom);
                if (offsetBottom <= 500) {
                    console.log('bbb',this.first_loading);
                    if (this.loadingMore || this.infiniteEnded || this.first_loading) return;
                    // console.log('触发触底加载...',new Date().getTime());
                    this.loadingMore = true;
                    this.getInfiniteList().finally(()=>{
                        this.loadingMore = false;
                    });
                }
            });
        },
        choose_category(id) {
            if(this.selected_category_id === id) {
                this.selected_sub_category_id = 0
                this.getInfiniteList(true);
            }
            this.selected_category_id = id
        },
        choose_sub_category(id) {
            this.selected_sub_category_id = id
        },
        async getCategoryList() {
            return InfoCategory().then(response => {
                this.category_list = response.data
                if(this.category_list.length > 0) {
                    this.selected_category_id = this.category_list[0].id
                }
            })
        },
        async getHotList() {
            InfoHotList({page: 1, limit: 10, category_id: this.selected_sub_category_id || this.selected_category_id}).then(response => {
                this.hot_list = response.data
            })
        },
        async getInfiniteData(pageIndex,pageSize){
            console.log('pageIndex',pageIndex);
            return InfoList({
                page: pageIndex, 
                limit: pageSize, 
                category_id: this.selected_sub_category_id || this.selected_category_id,
                keyword:  this.keyword || '',
            });
        },
        async onGetBannerList(){
            const {data} = await GetBannerList({position: C.BANNER_POSITION_INFO,info_cate_id:this.selected_category_id || ''});
            this.banner_list = [];
            this.show_swiper = false;
            this.swiperOptions.loopedSlides = data.length;
            this.banner_list = data;

             // 在更新banner_list后，需要手动更新Swiper
             this.$nextTick(() => {
                this.show_swiper = true;
            });
        },
        onDetailClick(item){
            window.open(`${location.protocol}//${location.host}/info/detail?uuid=${item.uuid}`)
            // this.$router.push({name:'InfoDetail',query:{uuid:item.uuid}});
        },
        onSwiperClick(item){
            console.log('轮播点击', item);
            // 记录点击统计
            this.recordBannerClick(item);
            const url = item.url;
            if(!url) return;
            if (url.startsWith('http')) {
                // window.location.href = url;
                window.open(url,'_blank');
            } else {
                this.$router.push(url);
            }
        },
        // 轮播图初始化回调
        onSwiperInit() {
            // 初始化时记录第一张轮播图的曝光
            this.recordBannerExposure(0);
        },
        // 轮播图切换回调
        onSlideChange() {
            const swiper = this.$refs.mySwiper;
            if (swiper && swiper.swiper) {
                const activeIndex = swiper.swiper.realIndex; // 获取真实索引（考虑循环模式）
                this.currentBannerIndex = activeIndex;
                // 记录当前轮播图的曝光
                this.recordBannerExposure(activeIndex);
            }
        },
        // 记录轮播图曝光
        async recordBannerExposure(index) {
            try {
                const banner = this.banner_list[index];
                if (banner && banner.id) {
                    // 检查该banner是否已经统计过曝光
                    if (this.exposedBanners.has(banner.id)) {
                        return;
                    }
                    // 记录该banner已曝光
                    this.exposedBanners.add(banner.id);
                    // 调用接口统计曝光
                    await AddBannerStat({
                        banner_id: banner.id,
                        stat_type: 2, // 2表示曝光
                        user_id: this.$store.state.userInfo.id || 0
                    });
                }
            } catch (e) {
                console.log('曝光统计失败', e);
            }
        },
        // 记录轮播图点击
        async recordBannerClick(banner) {
            try {
                if (banner && banner.id) {
                    await AddBannerStat({
                        banner_id: banner.id,
                        stat_type: 1, // 1表示点击
                        user_id: this.$store.state.userInfo.id || 0
                    });
                }
            } catch (e) {
                console.log('点击统计失败', e);
            }
        },


    }
}
</script>
<style lang="scss" scoped>
@import './news.scss';
</style>
